export default "__VITE_PUBLIC_ASSET__c973db79__"